// Ported from the Webflow 404 utility page (no navbar/footer, like the original).
export default function NotFoundPage() {
  return (
    <>
      <a href="/" className="brand-center w-nav-brand">
        <img src="/assets/cdn/655ccb07963af7dd90c4154e_Abilitics%20Logo.svg" loading="eager" alt="Abilitics" className="logo" />
      </a>
      <div className="utility-page-wrap">
        <div className="utility-page-content">
          <div className="subtitle blue">
            404
            <br />
          </div>
          <h2 className="heading-account">Page Not Found</h2>
          <p className="paragraph-account">The page you are looking for doesn&#x27;t exist or has been moved</p>
          <a href="/" className="button w-button">Back to Home</a>
        </div>
      </div>
    </>
  );
}
